export default function infoUriFromEntity(entity: string) {
  return `/${entity}/List`;
}
